import { useCallback } from 'react';

import { useDispatch, useStore } from 'react-redux';

import { logErrorWrapper } from '../../../../services/logWrapper';
import { setDirectnessFilterEnabled } from '../../actions/filter-actions';
import {
  SET_DIRECTNESS_FILTER_ANALYSIS,
  TRIGGER_SET_DIRECTNESS_FILTER,
} from '../constants/actionsConstants';
import { CHECK_SOURCE } from '../constants/dataTypeConstants';
import dateValidationDispatcher from '../dateValidationDispatcher';

import type { State } from '../../selectors/types';

const triggerDirectnessFilterStarted = (filtering: boolean) => ({
  type: `${TRIGGER_SET_DIRECTNESS_FILTER}_STARTED` as const,
  payload: filtering,
});

const setDirectnessAnalytics = () => ({
  type: SET_DIRECTNESS_FILTER_ANALYSIS,
  payload: undefined,
  meta: {
    googleAnalyticsLogEvent: SET_DIRECTNESS_FILTER_ANALYSIS,
  },
});

export const useDirectnessFilter = () => {
  const dispatch = useDispatch();
  const store = useStore<State>();

  const toggleFilter = useCallback(
    async (checked: boolean, source: string) => {
      dispatch(triggerDirectnessFilterStarted(checked));

      try {
        if (source === CHECK_SOURCE) {
          dispatch(setDirectnessAnalytics());
        }

        dateValidationDispatcher.ensureValidDates(store.getState(), dispatch);
      } catch (error: unknown) {
        logErrorWrapper(error as Error, {
          message: 'triggerDirectnessFilterActionChain error',
          component: 'useDirectnessFilter',
        });
      }
    },
    [dispatch, store],
  );

  const setFilterEnabled = useCallback(
    (enabled: boolean) => {
      dispatch(setDirectnessFilterEnabled(enabled));
    },
    [dispatch],
  );

  return { toggleFilter, setFilterEnabled };
};
